
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.212 6.235H7.71V4.733h1.502v1.502zm0 6.01H7.71V7.737h1.502v4.506zM8.47 16c4.146 0 7.504-3.365 7.504-7.511 0-4.147-3.358-7.512-7.504-7.512C4.315.977.95 4.342.95 8.49.95 12.635 4.315 16 8.469 16zM8.46 2.48c3.32 0 6.01 2.689 6.01 6.009 0 3.32-2.69 6.009-6.01 6.009a6.007 6.007 0 01-6.009-6.01c0-3.32 2.69-6.008 6.01-6.008z","fill":"#ABAFB5"}})])
          )
        }
      }
    